// extracted by mini-css-extract-plugin
export var Accordion = "accordion-module--Accordion--eba64";
export var Accordion_arrow = "accordion-module--Accordion_arrow--1c22c";
export var Accordion_content = "accordion-module--Accordion_content--c4bcb";
export var Accordion_title = "accordion-module--Accordion_title--e30ea";
export var Accordion_titleMobileMenu = "accordion-module--Accordion_titleMobileMenu--5f452";
export var Accordion_toggler = "accordion-module--Accordion_toggler--b8546";
export var slideIn = "accordion-module--slide-in--23a87";
export var slideInFromRight = "accordion-module--slide-in-from-right--3c135";